module.exports = __webpack_public_path__ + "fonts/dropify.4e8b017a.eot";